import React from 'react';
import ReactTable from "react-table";
import classnames from 'classnames';
import { GridLoader } from 'react-spinners';

const tableConstants = {
    pageText: "",
    previousText: "< Previous",
    nextText: "Next >",
    defaultPageSize: 5,
    minRows: 3
};

const getLoadingComponent = (props) => {  
    return <div className={classnames("d-flex align-items-center justify-content-center", props.loading ? "-loading -active" : "")}>
      <GridLoader
        sizeunit={"px"}
        size={10}
        color={'#00BFFF'}
        className={"margin-left: 50%; width: 42px !important; font-size:0 !important; top: 30% !important"}
        loading={props.loading} />
    </div>
}

const Table = (props) => {
    return (

        <ReactTable {...tableConstants}
            {...props}
        LoadingComponent={getLoadingComponent}
        />
    )
}

export default Table
